import { anatomy } from "@zag-js/select";
import { sva } from "@agapi/ui/panda/css";
export const selectStyles = sva({
    slots: anatomy.keys(),
    base: {
        root: {
            position: "relative",
            width: "auto",
            display: "flex",
            _disabled: {
                pointerEvents: "none",
            }
        },
        trigger: {
            display: "flex",
            gap: "2",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            padding: "3",
            borderRadius: "forms",
            border: "1px solid",
            borderColor: "borders.base",
            background: "surface.default.background",
            userSelect: "none",
            color: "text.primary",
            cursor: "pointer",
            transition: "0.18s ease",
            whiteSpace: "nowrap",
            _hover: {
                borderColor: "forms.action",
            },
            _open: {
                borderColor: "forms.action",
            },
            _disabled: {
                pointerEvents: "none",
                borderColor: "borders.subdued",
                background: "surface.base.background",
                color: "text.subdued",
            },
        },
        indicator: {
            transition: "0.18s ease",
            color: "text.subdued",
            "[data-state=open] &": {
                transform: "rotate(180deg)"
            }
        },
        label: {
            fontWeight: "bold",
            lineHeight: "none",
            whiteSpace: "nowrap",
        },
        content: {
            margin: 0,
            listStyle: "none",
            borderRadius: "forms",
            border: "1px solid",
            borderColor: "forms.action",
            background: "surface.default.background",
            boxShadow: "3px 3px 16px -12px rgba(0,0,0,0.9)",
            minWidth: { lg: "300px" },
            maxHeight: "350px",
            overflowY: "scroll",
            "&::-webkit-scrollbar": {
                display: "none",
            },
            scrollbarWidth: "none",
            transition: ".3s ease",
            opacity: 0,
            transform: "translateY(-8px)",
            _open: {
                opacity: 1,
                transform: "translateY(0)"
            },
        },
        list: {
            listStyle: "none",
        },
        item: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "3",
            p: "3",
            userSelect: "none",
            cursor: "pointer",
            transition: "0.18s ease",
            _hover: { bg: "surface.subdued.background" },
            _active: { bg: "surface.primary.subdued.background", transform: "scale(0.99)" },
            _highlighted: {
                bg: "surface.subdued.background",
            },
            _selected: {
                backgroundColor: "surface.primary.subdued.background",
                _hover: {
                    backgroundColor: "surface.primary.tonal.background",
                },
                _highlighted: {
                    bg: "surface.primary.tonal.background",
                },
                _active: {
                    bg: "surface.primary.subdued.background",
                },
            }
        },
        itemText: {
            flexGrow: 1,
        }
    },
    variants: {
        fullWidth: {
            true: {
                root: {
                    width: "100%",
                }
            }
        }
    }
});
export const classes = selectStyles();
